import Link from 'next/link';
import React, { useCallback, useContext } from 'react';
import DropdownContext from '../_dropdownContext';

interface Props {
  href: string;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
  isLink: boolean;
  id?: string;
}

export default function LinkOrButton({ href, className, children, isLink, onClick, id }: Props) {
  const { setIsOpen: setIsOpenDropdown } = useContext(DropdownContext);
  const onNavigate = useCallback(() => {
    setIsOpenDropdown(false);
  }, [setIsOpenDropdown]);
  if (isLink) {
    return (
      <Link href={href} className={className} prefetch={false} id={id} onClick={onNavigate}>
        {children}
      </Link>
    );
  }
  return (
    <button type="button" onClick={onClick} className={className} id={id}>
      {children}
    </button>
  );
}
